import { jsxs, jsx } from 'react/jsx-runtime';
import { LayoutGroup } from 'framer-motion';
import { useRef, useState } from 'react';
import { styled, css } from 'styled-components';
import { Flex } from '@fabric-app/ui/components/Flex';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { useQueryFolder } from '../../../queries/useQueryFolder.js';
import { isQueryEnabled } from '@fabric-app/queries/utilities';
import { useDebounce } from '@fabric-app/hooks/useDebounce';
import { mediaMobile } from '@fabric-app/ui/constants/styled-utils';
import RecapSummaryButton from '../../../../recap/components/RecapSummaryButton.js';
import { VirtualResourceMasonry } from './VirtualResourceMasonry.js';

const ResourceMasonryDivision = ({ viewMode, zoomLevel: zoomLevelProp, resources, titleProp, style, splitResourceGroup, resourcesTotalCount, colorLabels, disableItemPreviewContextMenu, resourceId, previewSelectedFdocs, canMultiSelect, resourcePreviewProps, layoutId, onResourceClick, canModifyContent, virtualGridOptions, onInfiniteTrigger, containerWidth }) => {
  const zoomLevel = viewMode === "Grid" ? zoomLevelProp : 1;
  const gridContainerRef = useRef(null);
  const [initialContentRendered, setInitialContentRendered] = useState(false);
  const { folder } = useQueryFolder({
    resourceId
  }, {
    enabled: isQueryEnabled([
      !!resourceId,
      !titleProp
    ])
  });
  const title = titleProp || folder?.name || "";
  const debouncedLayoutId = useDebounce(layoutId, 0);
  const scrollYMargin = gridContainerRef.current?.offsetTop ?? 0;
  return /* @__PURE__ */ jsxs(Division, {
    visible: initialContentRendered,
    "data-division-title": title,
    children: [
      title && /* @__PURE__ */ jsx(DivisionHeader, {
        children: /* @__PURE__ */ jsxs(Title, {
          children: [
            /* @__PURE__ */ jsx("span", {
              children: title
            }),
            splitResourceGroup?.recap && /* @__PURE__ */ jsx(RecapSummaryButton, {
              ...splitResourceGroup?.recap
            })
          ]
        })
      }),
      /* @__PURE__ */ jsx(GridWrapper, {
        ref: gridContainerRef,
        "data-droppable": true,
        style,
        children: /* @__PURE__ */ jsx(LayoutGroup, {
          id: `${layoutId}--${viewMode}`,
          children: /* @__PURE__ */ jsx(VirtualResourceMasonry, {
            onInitialContentRender: () => setInitialContentRendered(true),
            zoomLevel,
            resources,
            selectedResourceIds: previewSelectedFdocs,
            resourcesTotalCount,
            disableItemPreviewContextMenu,
            canMultiSelect,
            disableDrag: !canModifyContent,
            scrollYMargin,
            containerWidth,
            colorLabels,
            onInfiniteTrigger,
            virtualGridOptions,
            resourcePreviewProps,
            onResourceClick,
            disableLayoutAnimation: layoutId !== debouncedLayoutId
          })
        })
      })
    ]
  });
};
const Division = styled.div.withConfig({
  displayName: "ResourceMasonryDivision__Division",
  componentId: "sc-63447f43-0"
})([
  `display:flex;flex-direction:column;gap:20px;width:100%;`,
  ``
], ({ visible }) => !visible && css([
  `opacity:0;`
]));
const DivisionHeader = styled(Flex).attrs({
  alignItems: "center"
}).withConfig({
  displayName: "ResourceMasonryDivision__DivisionHeader",
  componentId: "sc-63447f43-1"
})([
  `height:52px;`
]);
const Title = styled.h3.withConfig({
  displayName: "ResourceMasonryDivision__Title",
  componentId: "sc-63447f43-2"
})([
  `font-weight:700;font-size:22px;line-height:1.35;padding:10px 0;color:`,
  `;min-width:30px;white-space:nowrap;display:flex;flex-wrap:wrap;align-items:center;flex-grow:1;gap:14px;`,
  `{font-size:18px;line-height:21px;padding-left:10px;padding-bottom:0;}> span{overflow:hidden;text-overflow:ellipsis;}`
], cssVar["color-text-placeholder"], mediaMobile);
const GridWrapper = styled.div.withConfig({
  displayName: "ResourceMasonryDivision__GridWrapper",
  componentId: "sc-63447f43-3"
})([
  `user-select:none;img{-webkit-user-drag:none;user-select:none;}`
]);

export { ResourceMasonryDivision };
//# sourceMappingURL=ResourceMasonryDivision.js.map
